import { render, staticRenderFns } from "./EditMultiselectInputGroup.vue?vue&type=template&id=636dc556&scoped=true"
import script from "./EditMultiselectInputGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMultiselectInputGroup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditMultiselectInputGroup.vue?vue&type=style&index=0&id=636dc556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636dc556",
  null
  
)

export default component.exports